// extracted by mini-css-extract-plugin
module.exports = {"decor":"styles_decor__gSsR7","icon":"styles_icon__tj21K"};